import React from "react";

import classes from "./ActionButtons.module.scss";
import Section from "./../../../general/Section/Section";
import Button from "./../../../general/Button/Button";
import { Link } from "react-router-dom";

const ActionButtons = (props) => {
  return (
    <div className={classes.wrapper}>
      {/* <Link to="/dashboard/admin/advertise/user">
        Client Users
      </Link> */}
      <Link to="/dashboard/admin/advertise/campaign">
        + Create New Campaign
      </Link>
      {/* <Link to="/dashboard/admin/advertise/backdate/placeholders">
        Backdate Selection
      </Link> */}
    </div>

    // <Section className={classes.wrapper}>
    //   <Link path="/dashboard/admin/advertise/user" colors={["#34bbca"]} noShadow>
    //     Client Users
    //   </Link>
    //   <Button path="/dashboard/admin/advertise/campaign" colors={["#787ff6"]} noShadow>
    //     Create New Campaign
    //   </Button>
    //   <Button path="/dashboard/admin/advertise/backdate/placeholders" colors={["#FC575E"]} noShadow>
    //     Backdate Selection
    //   </Button>
    // </Section>
  );
};

export default ActionButtons;
